export default __webpack_public_path__ + "static/media/hind-vadodara-latin-400-normal.ad19de58.woff2";